import { ELEMENT_GESTURE_MOVABLE_CONTAINER } from '@components/ArtBoard/Canvas/hooks/events/useDragEvents'
import { Tooltip } from '@lib/components'
import { addArrowGridPoint } from '@store/migrationActions/thunkActions/thunkArrowsActions'
import type { AppState } from '@store/types'
import { getId } from '@store/utils'
import { setSelectedArrowPointId } from '@storeOld/reducers/canvas/canvas'
import type React from 'react'
import { useDispatch } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

import { useScaleZoom } from '@/hooks'
import css from './ArrowLineAnchor.module.scss'

type Props = {
  id: string
  index: number
}

const ArrowLineAnchor: React.FC<Props> = ({ id, index }) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()

  const { scale } = useScaleZoom()

  const onClick = (e: React.MouseEvent) => {
    const ref = document.getElementById(ELEMENT_GESTURE_MOVABLE_CONTAINER)

    if (!ref) {
      return
    }

    const pointId = getId()
    const canvasRef = document.querySelector('.Tree-root') as HTMLElement

    const target = e.target as HTMLElement
    const targetRect = target.getBoundingClientRect()
    const canvasRect = canvasRef.getBoundingClientRect()
    const elementPosition = {
      x: (targetRect.left + targetRect.width / 2 - canvasRect.left) / scale,
      y: (targetRect.top + targetRect.height / 2 - canvasRect.top) / scale,
    }

    dispatch(addArrowGridPoint(id, pointId, elementPosition, index))
    dispatch(setSelectedArrowPointId(pointId))
  }

  const addAnchorStyle = {
    width: 5 * scale,
    height: 5 * scale,
    borderWidth: 2 * scale,
  } as React.CSSProperties

  return (
    <Tooltip content="Add anchor" position="top">
      <div className={css.container} onClick={onClick} style={addAnchorStyle} />
    </Tooltip>
  )
}

export default ArrowLineAnchor
